// extracted by mini-css-extract-plugin
export default {"header":"styles_header__UJm1K","headerBig":"styles_headerBig__WIOS-","header_auth":"styles_header_auth__TYKcG","center":"styles_center__RWa3D"};